/**
 *  PERMITE UNICAMENTE NÚMEROS Y UN PUNTO DECIMAL EN EL CAMPO INPUT
 * @param {String} e 
 * @param {Function} setImporte 
 */
const campoDeNumeros = (e, setImporte) => {
    if (!/^[0-9]*\.?[0-9]*$/.test(e.substring(e.length - 1))) e = e.replace(/.$/, "");
    setImporte(e)
}

export default campoDeNumeros;